import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicPreview({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M10 5.75a4.25 4.25 0 013.49 6.68l1.3 1.3a.75.75 0 11-1.05 1.07l-1.31-1.31A4.25 4.25 0 1110 5.75zM11.65 1c1 0 1.85.77 1.85 1.75v2a.75.75 0 11-1.5 0v-2c0-.12-.14-.25-.35-.25h-8.8c-.2 0-.35.13-.35.25v10c0 .12.14.25.35.25h1.9a.75.75 0 110 1.5h-1.9c-1 0-1.85-.77-1.85-1.75v-10C1 1.77 1.84 1 2.85 1zM10 7.25a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicPreview.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicPreview.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicPreview svgRef={ref} {...props} />);
export default ForwardRef;
